// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunks/" + ({"200":"insights","328":"postMetrics","1275":"search-insights","3524":"app"}[chunkId] || chunkId) + "-" + {"200":"5a333a73","328":"8eb89fc6","1275":"7770208a","3524":"d2e242fc","7482":"43f97571"}[chunkId] + ".css";
};